import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator,
} from '@angular/forms';
import {
	Directive,
	Input,
} from '@angular/core';

import {
	isBoolean,
	isEmpty,
	isObject,
} from 'lodash';
import { commonUtilitiesCoreService } from '../../services/core.service';

@Directive({
	selector: '[commonRequired]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: CommonRequiredDirective,
		multi: true,
	}],
})
export class CommonRequiredDirective implements Validator {
	@Input() commonRequired: boolean;

	private errorObject = {
		CommonRequiredValidator: true,
	};

	validate (control: AbstractControl): ValidationErrors | null {
		// валидация отключена по флагу
		if (this.commonRequired === false) {
			return null;
		}

		// особые случаи валидации
		if (isBoolean(control.value)) {
			return control.value ? null : this.errorObject;
		} else if (isObject(control.value)) {
			return !isEmpty(control.value) ? null : this.errorObject;
		}

		return commonUtilitiesCoreService.hasValue(control.value) ? null : this.errorObject;
	}
}
